// Takes a string value and returns a positive floating point number.
export const formatPositiveNumber = value => {
  let newValue = value;

  // Adds a 0. if the user types in a "." to start.
  if (newValue.startsWith('.')) {
    newValue = '0.';
  }

  // Removes any non number item that may be added
  // + becomes "";
  // 25b becomes 25
  if (isNaN(newValue)) {
    const newValueArray = newValue.split('');
    newValueArray.pop();
    newValue = newValueArray.join('');
  }

  if (newValue > 100) {
    // If number is 1001 for example returns 100, or 1009 returns 100.
    if (Number(newValue) >= 1000 && Number(newValue) < 1010) {
      newValue = newValue
        .split('')
        .slice(0, 3)
        .join('');
    } else {
      // Returns first two digits if over 100. 255 becomes 25.
      newValue = newValue
        .split('')
        .slice(0, 2)
        .join('');
    }
    // Prevents 100. from being entered
  } else if (Number(newValue) === 100) {
    return 100;
  }

  newValue = newValue.trim();

  // Parses Number to float eliminating leading zeroes and negative numbers
  // In certain cases we don't want the data sanitized.
  // i.e 0., 3., 3.0 as these could be decimal continuations
  if (
    !newValue.startsWith('0.') &&
    newValue &&
    !newValue.endsWith('.') &&
    !newValue.endsWith('.0')
  ) {
    newValue = Math.abs(parseFloat(newValue));
  }

  return newValue;
};



// WEBPACK FOOTER //
// ./src/forms/utils.js